import { setter } from './utils';
import { LOAD_OUTLINE } from '../actions/types';

export default setter(LOAD_OUTLINE, []);
